import { c as _c } from "react/compiler-runtime";
import { IconLink } from '@/components/Atoms/IconLink/IconLink';
import Popout from '@/components/Icons/Popout';
import { MultiSessionEventTemplate } from '@/components/Templates/Events/MultiSessionEventTemplate';
import useTranslation from '@/hooks/useTranslation';
import type { IEvent, IEventSession, IPerson } from '@/interfaces';
import type { FC } from 'react';
interface IForumPageProps {
  event: IEvent;
  sessions: {
    session: IEventSession;
    participants: IPerson[];
  }[];
}
export const ForumPage: FC<IForumPageProps> = t0 => {
  const $ = _c(24);
  const {
    event,
    sessions
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Date();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== event.endDate) {
    t2 = new Date(event.endDate);
    $[1] = event.endDate;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const hasEnded = t1 > t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("common:SiteSection.events");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = [{
      url: "/events",
      label: t3
    }];
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== event.registrationUrl || $[8] !== hasEnded || $[9] !== t) {
    t5 = event.registrationUrl && !hasEnded && <IconLink icon={<Popout />} text={t("Event.Registration.registration")} href={event.registrationUrl} target="_blank" rel="noopener noreferrer" />;
    $[7] = event.registrationUrl;
    $[8] = hasEnded;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== sessions) {
    t6 = sessions?.map(_temp);
    $[11] = sessions;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== event.description || $[14] !== event.endDate || $[15] !== event.isDateProvisional || $[16] !== event.leadImage || $[17] !== event.location || $[18] !== event.startDate || $[19] !== event.title || $[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <MultiSessionEventTemplate breadcrumbs={t4} leadImage={event.leadImage} mainTitle={event.title} subTitle={event.location} isDateProvisional={event.isDateProvisional} startDate={event.startDate} endDate={event.endDate} description={event.description} moreDetail={t5} sessions={t6} />;
    $[13] = event.description;
    $[14] = event.endDate;
    $[15] = event.isDateProvisional;
    $[16] = event.leadImage;
    $[17] = event.location;
    $[18] = event.startDate;
    $[19] = event.title;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
function _temp(eventSession) {
  return {
    item: eventSession.session,
    hasSlides: eventSession.session.hasSlides,
    participants: eventSession.participants
  };
}